import IMAGES from "../../images/Images";
import {
  useSearchParams,
  Router,
  NavLink,
  useNavigate,
} from "react-router-dom";
import { toggleClass } from "../../utils/classHandling";
import { getRequest } from "../../apiService";
function ActionIconContainer_Page(props) {

   const navigate = useNavigate();
  function execIconMethod(x) {
    // alert("clicked with a method of: "+method+" and an id of: "+id);
    if (x.method === "printPage") {
      // alert("print has been triggered");
      print();
    } else if (x.method === "printPageReact") {
      document.getElementById("page-print-btn").click();
      if (
        typeof props.apiFolderPrint !== "undefined" &&
        typeof props.target !== "undefined"
      ) {
        logChecklistPrint(props.apiFolderPrint, props.target);
      }
    } else if (x.method == "toggle") {
      togglePopUpVisibility(x.id, "flex");
    } else if (x.method == "toggle_grid") {
      togglePopUpVisibility(x.id, "grid");
    } else if (x.method == "mulitPage-toggle") {
      togglePopUpVisibility(x.id, "flex");
      props.clickMethod(x.id);
    } else if (x.method == "parentClick") {
      props.clickMethod(x.id);
      if (["showSales", "showOthers", "toggleCompetitorsLabels"].includes(x.id)) {
        toggleClass(x.id, "active-icon");
      }
    } else if (x.method == "navBack") {
      history.back();
    }else if (x.method == "gotohub") {
    navigate(x.location);
  }else if (x.method == "gotoEdit") {
      // Navigate to edit page
      const currentPath = window.location.pathname;
      const editPath = currentPath.replace("/review/", "/edit/");
      navigate(editPath);
    } else {
      alert("functionality being built");
    }
  }

  const logChecklistPrint = async (apiFolder, target) => {
    const result = await getRequest(`${apiFolder}/print/${target}`);

    // // if (result.success) {

    // // } else {
    //     console.error("Failed to load smart call list:", result.error);
    //   }
  };

  function togglePopUpVisibility(id, displayType) {
    // let targetKeys = {
    //   glossary: "popUp-display",
    //   "campaign-new": "popUp-display",
    //   add_user: "popUp-display",
    //   viewComp: "popUp-display",
    //   add_agency: "popUp-display",
    //   manageUsers: "popUp-display",
    //   kpi: "popUp-display",
    //   addChase: "popUp-display",
    //   add_suburb: "popUp-display",
    // };
    const nonPopupTarget = [{ id: "", el: "" }];
    const match = nonPopupTarget.filter((f) => f.id == id);
    const el_key = match.length > 0 ? match[0].el : "popUp-display";
    let el = document.getElementById(el_key);
    el.style.display === displayType
      ? (el.style.display = "none")
      : (el.style.display = displayType);
  }

  document.addEventListener("keydown", function (e) {
    const printingNormal = props.data.filter(
      (f) => f.method === "printPage"
    ).length;
    if (e.ctrlKey && e.key === "p" && Number(printingNormal) === 0) {
      e.preventDefault();
      document.getElementById("page-print-btn").click();
    }
  });

  return (
    <>
      <div
        id={props.id}
        className={
          typeof props.disabled !== "undefined" && props.disabled
            ? "container-actions print-hidden action-" +
              props.orientation +
              " iconsUnSelectable"
            : "container-actions print-hidden action-" + props.orientation + " "
        }
      >
        {props.data.length > 0
          ? props.data.map((x, index) => (
              <div
                key={index}
                className="action-icon clickable"
                title={x.hoverDesc}
              >
                {x.icon !== "" ? (
                  <span
                    id={x.id}
                    className="material-symbols-outlined"
                    onClick={() => execIconMethod(x)}
                  >
                    {x.icon}
                  </span>
                ) : (
                  <a
                    className="action-link-img"
                    href={x.link}
                    target="blank"
                    title={x.hoverDesc}
                  >
                    <img
                      style={{ height: "30px", width: "30px" }}
                      src={IMAGES[x.img]}
                      alt={x.altDesc}
                    />
                  </a>
                )}
              </div>
            ))
          : null}
      </div>
    </>
  );
}
export default ActionIconContainer_Page;
